// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> isabella-court
// Generated: 2026-10-29T18:34:06.961Z
// Counts: 0 design, 47 content, 51 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>3 and 4 Bedroom Floor Plans at Isabella Court</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Search Available Rental Homes in Leland, NC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility at Isabella Court in Leland, NC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities at Isabella Court in Leland, NC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, you get granite kitchens with Energy-Star stainless appliances, an in-home washer and dryer, and roomy closets. Outside, there's a fenced backyard, lawn care that's handled for you, a community dog park and concierge service. <a href=\"/amenities\">See every amenity</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to live, less to maintain</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Isabella Court's shared spaces are mostly outdoors: there's an on-site dog park, a pond with open green space around it, and lawns kept up by our maintenance crew. Concierge service is there whenever you need a hand.</p>",
    "mappedField": null
  },
  "amenityhighlights.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Home Features and Community Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "aroundthearea.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Minutes from Downtown Wilmington and the Brunswick Riverwalk</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Isabella Court</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactdetails.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Questions About Our Homes for Rent in Leland, NC?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhelp.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Leasing and Application Questions</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqsearch.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Isabella Court Frequently Asked Questions</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes a filter change twice a year, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Move-in savings on select homes</p>",
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Photo Gallery of Isabella Court Homes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Brand-New Homes for Rent in Leland, NC at Isabella Court</p>",
    "generatedValue": "<p>Brand-new rental homes in Leland, minutes from Wilmington</p>",
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Available Home at Isabella Court</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Isabella Court the week is built around home, not a clubhouse: lawn maintenance keeps your weekends open, the community dog park handles the evening walk, and concierge service takes care of the small stuff. See everything included on the <a href=\"/amenities\">amenities</a> page.</p>",
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the Isabella Court Neighborhood in Leland, NC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From Isabella Park Boulevard it's a quick drive to the boardwalk trails at Westgate Nature Park and the river views at Belville Riverwalk. Downtown Wilmington's Riverwalk, its restaurants and big employers like the Port of Wilmington are just across the river. <a href=\"/neighborhood\">Explore the neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Leland living on the Cape Fear's west bank</p>",
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet-Friendly Living at Isabella Court</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Dogs get a fenced backyard at home and an on-site dog park for running off energy. For longer outings, Westgate Nature Park's boardwalk trails and the 900-plus acres of Brunswick Nature Park are a short drive away. See the full <a href=\"/pet-policy\">pet policy</a> for details.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Isabella Court Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>3 and 4 Bedroom Rental Homes Built for Modern Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You for Contacting Isabella Court</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyou.title": {
    "overrideType": "VALUE",
    "customValue": "<p>What Happens Next</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourgallery.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Rental Homes in Leland, NC Daily from 8am to 8pm</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Self-Guided Tour of Isabella Court</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Look through the Kershaw and Evans homes in our <a href=\"/virtual-tours\">virtual tours</a>, then come see one in person, either on your own schedule with a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "touroptions.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the Right Rental Home Layout in Leland, NC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tours-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours of Isabella Court Homes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Explore Isabella Court's three- and four-bedroom rental homes from anywhere: pick a tour from the list and look around at your own pace, then <a href=\"/schedule-a-tour\">book a self-guided tour</a> to see them in person in Leland.</p>",
    "mappedField": null
  },
  "virtualtourembed.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the Kershaw Home in 3D</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Fenced-In Backyards"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-61f9-70c8-bdaa-cf82800b56b4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Isabella Court homes with private backyards along neighborhood streets"
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-130a-775c-acef-163c33ce34bd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two modern townhouses with attached garages and manicured lawns under a bright blue sky."
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Electronic Thermostat"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9e-1417-76d7-97cc-39b777a04c1b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright and airy living room with hardwood floors and large windows."
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-2ce5-779f-989b-162f4ab53893.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Isabella Court homes with driveways and green space"
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Concierge"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-1e71-747d-a99e-4eff27ece66b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story home with covered front porch, brick and siding exterior and attached garage"
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Large Closets"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-d9a2-764e-82f5-e5cf2c705a0b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Empty walk-in closet with wire shelving"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-4c37-70ae-8fde-805125bdc45e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a newly developed neighborhood with rows of houses surrounding a small pond."
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-0eb8-77c2-9318-b66a5dadb8d4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two houses with garages are shown in the image."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-f0e0-764f-b97a-d4f0267349c2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with a granite island, white cabinets and stainless steel appliances"
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-4c37-70ae-8fde-805125bdc45e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Isabella Court's rows of homes around a small pond"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Community Pond"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-3b24-76dc-bd24-85ff994c23c2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A bird's eye view of a residential area with houses and a winding road."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Green Space"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-130a-775c-acef-163c33ce34bd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two modern townhouses with attached garages and manicured lawns under a bright blue sky."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Care"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-22ba-74fc-906c-7f8a0ee36e87.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Granite Kitchens"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-ff5f-7727-bb8f-5900b59f6376.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White top-load washer and front-load dryer in laundry closet."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "In-Home Laundry"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-d9a2-764e-82f5-e5cf2c705a0b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Empty walk-in closet with wire shelving"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Walk-In Closets"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-0eb8-77c2-9318-b66a5dadb8d4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story Isabella Court rental homes with attached garages and landscaped front yards"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-6908-74ca-81d3-f4ad561d7aab.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living area with light wood-look flooring and large windows"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-e083-745c-8685-3c2e858cfbff.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story home with stone accents, purple shutters and an attached garage"
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-22ba-74fc-906c-7f8a0ee36e87.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white cabinets, granite island and stainless steel appliances"
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-7133-767d-8dd7-f3dcc2014618.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living room and kitchen with a large island and wood-look floors"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-4c37-70ae-8fde-805125bdc45e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Isabella Court's streets of homes around a small pond"
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9e-04e8-73fc-945f-d22579868de9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story home with brick and gray siding and a two-car garage"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-0a56-745d-84e3-47b04b98f7cd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright living room with wood-look floors and French doors to the backyard"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-e65e-76bf-a170-ec8148b00dbe.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room open to a kitchen with breakfast bar and stairs to the upper level"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-130a-775c-acef-163c33ce34bd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story homes with attached garages and green lawns under a blue sky"
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Your Own Backyard"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Every home has a fenced-in backyard, and lawn maintenance means you spend Saturday enjoying the grass instead of mowing it."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park Meetups"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The community dog park is where neighbors swap hellos while the dogs run off some energy."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to Focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "With three or four bedrooms, a spare room makes a quiet home office, and smart-home tech lets you set the thermostat without leaving your desk."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-b0a0-71e6-9fd5-472171e94f05.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Wooded trail at Westgate Nature Park in Leland, NC"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Westgate Nature Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-40c9-7038-82c3-ce247128ef68.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Isabella Court homes with open green space and a pond"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Open green space"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-3a79-7526-be6b-c882ec7bbb2f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story Isabella Court homes with white siding, black shutters and attached garages"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Two-story homes"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-7133-767d-8dd7-f3dcc2014618.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room and kitchen area with a large island and stainless steel sink."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-22ba-74fc-906c-7f8a0ee36e87.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Granite kitchen"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9d-e083-745c-8685-3c2e858cfbff.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a two-story home with a garage and purple shutters."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Home exterior"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-0a56-745d-84e3-47b04b98f7cd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Empty living room with hardwood floors and French doors leading outside."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Living room"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-3b24-76dc-bd24-85ff994c23c2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A bird's eye view of a residential area with houses and a winding road."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Community aerial"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful leasing"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "Trever was beyond helpful"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Spacious layouts"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "spacious layout and modern kitchen"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Self-guided tours"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "loved the self guided tour process"
      }
    }
  },
  "reviewthemes.chip_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Big closets"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "the huge walk-in closet"
      }
    }
  },
  "reviewthemes.chip_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Peaceful neighborhood"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "the community is peaceful"
      }
    }
  },
  "reviewthemes.chip_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Beautiful homes"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "The homes are beautiful, spacious"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167638/01a15a9e-04e8-73fc-945f-d22579868de9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story home at Isabella Court with a brick and gray siding front and a two-car garage"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
